/**
 * Defines the constants used by the Attachments module.
 * @file
 * @author Jason Haddix <jason@thebrandingfarm.com>
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 */
export const VUEX_ATTACHMENTS_INDEX_REQUEST               = 'VUEX_ATTACHMENTS_INDEX_REQUEST'
export const VUEX_ATTACHMENTS_INDEX_SUCCESS               = 'VUEX_ATTACHMENTS_INDEX_SUCCESS'
export const VUEX_ATTACHMENTS_INDEX_FAILURE               = 'VUEX_ATTACHMENTS_INDEX_FAILURE'
export const VUEX_ATTACHMENT_SHOW_REQUEST                 = 'VUEX_ATTACHMENT_SHOW_REQUEST'
export const VUEX_ATTACHMENT_SHOW_SUCCESS                 = 'VUEX_ATTACHMENT_SHOW_SUCCESS'
export const VUEX_ATTACHMENT_SHOW_FAILURE                 = 'VUEX_ATTACHMENT_SHOW_FAILURE'
export const VUEX_ATTACHMENT_CREATE_REQUEST               = 'VUEX_ATTACHMENT_CREATE_REQUEST'
export const VUEX_ATTACHMENT_CREATE_SUCCESS               = 'VUEX_ATTACHMENT_CREATE_SUCCESS'
export const VUEX_ATTACHMENT_CREATE_FAILURE               = 'VUEX_ATTACHMENT_CREATE_FAILURE'


export const VUEX_ATTACHMENTS_UPDATE_ITS_PRODUCT_TERM     = 'VUEX_ATTACHMENTS_UPDATE_ITS_PRODUCT_TERM'
export const VUEX_ATTACHMENTS_GET_ITS_PRODUCTS            = 'VUEX_ATTACHMENTS_GET_ITS_PRODUCTS'
export const VUEX_ATTACHMENTS_GET_ITS_PRODUCTS_SUCCESS    = 'VUEX_ATTACHMENTS_GET_ITS_PRODUCTS_SUCCESS'
export const VUEX_ATTACHMENTS_GET_ITS_PRODUCTS_FAILURE    = 'VUEX_ATTACHMENTS_GET_ITS_PRODUCTS_FAILURE'
export const VUEX_ATTACHMENTS_CLEAR_ITS_PRODUCT_DATA      = 'VUEX_ATTACHMENTS_CLEAR_ITS_PRODUCT_DATA'


export const VUEX_ATTACHMENTS_UPDATE_ITS_ASSET_TERM       = 'VUEX_ATTACHMENTS_UPDATE_ITS_ASSET_TERM'
export const VUEX_ATTACHMENTS_GET_ITS_ASSETS              = 'VUEX_ATTACHMENTS_GET_ITS_ASSETS'
export const VUEX_ATTACHMENTS_GET_ITS_ASSETS_SUCCESS      = 'VUEX_ATTACHMENTS_GET_ITS_ASSETS_SUCCESS'
export const VUEX_ATTACHMENTS_GET_ITS_ASSETS_FAILURE      = 'VUEX_ATTACHMENTS_GET_ITS_ASSETS_FAILURE'
export const VUEX_ATTACHMENTS_CLEAR_ITS_ASSET_DATA        = 'VUEX_ATTACHMENTS_CLEAR_ITS_ASSET_DATA'

export const VUEX_ATTACHMENTS_DELETE_ATTACHMENT           = 'VUEX_ATTACHMENTS_DELETE_ATTACHMENT'


export const VUEX_ATTACHMENT_PERFORM_ATTACH_TO_RESOLUTION = 'VUEX_ATTACHMENT_PERFORM_ATTACH_TO_RESOLUTION'